import { Modal } from "../../nq-component";
import { useEffect, useState } from "react";
import ProgressBar from "../ProgressBar";

function ProgressModal({ progress, generating, current, total }) {
  return (
    <>
      <Modal isOpen={generating}>
        <div className="d-flex flex-column p-4">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img
              alt="loading"
              src="/bean-eater.gif"
              width="80px"
              height="80px"
            />

            <h5 className="fw-bold text-muted">Downloading...</h5>
          </div>

          <div className="d-flex justify-content-between">
            <b className="m-0" style={{ color: "#e09552" }}>
              {progress}%
            </b>

            <div className="d-flex">
              <b className="m-0">{current}</b>
              <p className="m-0">/</p>
              <b className="m-0">{total}</b>
            </div>
          </div>

          <ProgressBar progress={progress} color={"#e09552"} />
        </div>
      </Modal>
    </>
  );
}

export default ProgressModal;
